import { LayoutDashboard, Users, Clock, ShoppingBag, FileEdit, Receipt, FileText } from "lucide-react";

export const NAV_GROUPS = [
  {
    title: "Genel",
    items: [{ id: "dashboard", label: "Genel Bakış", shortLabel: "Bakış", path: "/dashboard", icon: LayoutDashboard }],
  },
  {
    title: "Personel",
    items: [
      { id: "personel", label: "Personel Yönetimi", shortLabel: "Personel", path: "/personel", icon: Users },
      { id: "devam", label: "Devam Takibi", shortLabel: "Devam", path: "/devam", icon: Clock },
      { id: "istifa", label: "İstifa İşlemleri", shortLabel: "İstifa", path: "/istifa", icon: FileText },
    ],
  },
  {
    title: "Operasyon",
    items: [
      { id: "manav", label: "Manav Listesi", shortLabel: "Manav", path: "/manav", icon: ShoppingBag },
      { id: "veri-girisi", label: "Veri Girişleri", shortLabel: "Veri Girişi", path: "/veri-girisi", icon: FileEdit },
      { id: "zrapor", label: "Z-Rapor İşlemleri", shortLabel: "Z-Rapor", path: "/zrapor", icon: Receipt },
    ],
  },
];

export const NAV_ITEMS = NAV_GROUPS.flatMap((g) => g.items);

export const findNavItem = (path) => NAV_ITEMS.find((m) => m.path === path);

export const findNavGroup = (path) => NAV_GROUPS.find((g) => g.items.some((m) => m.path === path));
